// src/pages/ContentDetail/components/activity/VocabularyActivity.js
import React from 'react';
import { Box, Typography, Grid, Card, CardContent, alpha, Divider } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import ReadableText from '../../../../components/text/ReadableText';

const VocabularyActivity = ({ activity }) => {
  const theme = useTheme();
  

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h6" gutterBottom color="text.primary">
        {activity.activityTitle}
      </Typography>
      
      <Grid container spacing={3}>
        {activity.content.sentences.map((item, index) => {          
          return (
            <Grid item xs={12} md={6} key={index}>
              <Card
                variant="outlined"
                sx={{
                  height: '100%',
                  bgcolor: theme.palette.background.paper,
                  borderColor: theme.palette.divider,
                  '&:hover': {
                    borderColor: theme.palette.primary.main
                  }
                }}
              >
                <CardContent>
                  <Typography variant="subtitle1" color="primary" gutterBottom>
                    Sentence {index + 1}
                  </Typography>
                  <Typography variant="body1" paragraph color="text.primary">
                    {item.raw}
                  </Typography>
                  
                 <Divider sx={{ my: 1, borderColor: alpha(theme.palette.common.white, 0.1) }} />
                      <Box sx={{ mt: 2 }}>
                        <ReadableText text={item.readable} />
                      </Box>
                </CardContent>
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};

export default VocabularyActivity;